module.exports = __webpack_public_path__ + "static/media/horoscope-icon-11.c29b54f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-11.png
// module id = 1527
// module chunks = 0